import queryString from 'query-string';
import clientUrlParams from './clientUrlParams';

export const parseFullName = fullName => {
  const names = fullName.trim().split(' ');

  const lastName = names.pop();
  const firstName = names.join(' ');

  return { firstName, lastName };
};

const getStateFromUrl = () => {
  const query = window.location.search;
  if (!query) return { client: {} };

  const queryObject = queryString.parse(query);

  if (queryObject.fullName && !queryObject.firstName && !queryObject.lastName) {
    const parsedNames = parseFullName(queryObject.fullName);
    queryObject.firstName = parsedNames.firstName;
    queryObject.lastName = parsedNames.lastName;
  }

  return {
    client: clientUrlParams.reduce((params, param) => {
      if (!queryObject[param]) return params;
      return Object.assign({}, params, { [param]: queryObject[param] });
    }, {}),
    flow: queryObject.flow,
  };
};

export default getStateFromUrl;
